var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3493 4H19.7797L13.7331 10.9304L20.3333 20.3333H15.5579L11.0358 13.9611L5.36111 20.3333H4L10.3677 13.0426L4 4H8.82156L12.9773 9.87462L13.1079 9.96615L18.3493 4ZM18.2571 19.2564L8.22175 5.07692H6.12241C6.24606 5.33628 6.42785 5.57321 6.59211 5.80923C9.72451 10.3108 12.9907 14.7378 16.0885 19.2564H18.2571Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.0b480a117bba9cddef52e1c16d434897.svg";
export { ForwardRef as ReactComponent };